var ExtendPropertyDataToGoModelUtil = /** @class */ (function () {
    function ExtendPropertyDataToGoModelUtil(diagram, goModel) {
        this.diagram = diagram;
        this.goModel = goModel;
    }
    ExtendPropertyDataToGoModelUtil.prototype.saveComponentProperty = function (property, value) {
        this.diagram.model.setDataProperty(this.goModel, property, value);
    };
    ExtendPropertyDataToGoModelUtil.prototype.saveToGoJsModel = function (data) {
        this.saveComponentProperty('borderColor', data.borderColor);
        this.saveComponentProperty('backgroundColor', data.backgroundColor);
        this.saveComponentProperty('barColor', data.barColor);
        this.saveComponentProperty('useAlarmLimit', data.useAlarmLimit);
        if (data.useAlarmLimit && data.alarmLimit) {
            this.saveComponentProperty('upperLimit', data.alarmLimit.upperLimit);
            this.saveComponentProperty('lowerLimit', data.alarmLimit.lowerLimit);
            this.saveComponentProperty('upperLimitColor', data.alarmLimit.upperLimitColor);
            this.saveComponentProperty('lowerLimitColor', data.alarmLimit.lowerLimitColor);
        }
        else {
            delete this.goModel.upperLimit;
            delete this.goModel.lowerLimit;
            delete this.goModel.upperLimitColor;
            delete this.goModel.lowerLimitColor;
        }
    };
    return ExtendPropertyDataToGoModelUtil;
}());
export { ExtendPropertyDataToGoModelUtil };
